import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useChannel } from "./ws/useChannel";

export const MANUAL_FAULT_EVENTS_PATH = "/projects/:projectId(uuid)/manualFaultEvents" as const;
export const MANUAL_FAULT_EVENT_PATH =
  "/projects/:projectId(uuid)/manualFaultEvents/:manualFaultEventId(uuid)" as const;

export function useManualFaultEventsChannel(projectId: string) {
  const queryClient = useQueryClient();
  const invalidate = useCallback(() => {
    void queryClient.invalidateQueries({
      predicate: ({ queryKey }) =>
        queryKey[1] === projectId &&
        (queryKey[0] === MANUAL_FAULT_EVENTS_PATH || queryKey[0] === MANUAL_FAULT_EVENT_PATH),
    });
  }, [projectId, queryClient]);

  useChannel({ key: "manual_fault_events", projectId }, invalidate, true);
}
